import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Lato%22,%22arguments%22:[{%22weight%22:[%22400%22,%22700%22,%22900%22],%22style%22:[%22normal%22,%22italic%22],%22display%22:%22block%22,%22variable%22:%22--font-lato%22,%22subsets%22:[%22latin%22]}],%22variableName%22:%22lato%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Lato', 'Lato Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
